/**
 * UMA's approved eSIGN consent language. Shared across every UMA surface so the
 * disclosure captured on the certificate is identical wherever a lead is taken.
 * Treat as legal copy — do not reword.
 */
export const UMA_TCPA_DISCLOSURE =
  'By clicking the Request Info button below, I am providing my eSIGN signature and express written consent for Ultimate Medical Academy (UMA), onlinecollegeguide.io, and parties calling on its behalf, to call or text me at the number provided above for purposes relating to educational opportunities with UMA, including through the use of automatic telephone dialing technology and pre-recorded messages. I am authorized to consent to receive these communications at the phone number provided. I understand that I am consenting to receive calls and text messages regardless of whether the number provided is on any do not call list, either now or in the future. I acknowledge that my consent is not required to enroll, and I may revoke my consent at any time. I acknowledge that all calls may be recorded.'

export interface UMAProgram {
  /** Identifier used by the program picker on the UMA landing page. */
  slug: string
  /** URL segment for a dedicated program page. */
  routeSlug: string
  title: string
  shortTitle: string
  /** Value posted to the lead webhook as `mProgram`. */
  mProgram: string
  /**
   * Media Matchers codes for the same program, used by the neutral program
   * search. Separate from `mProgram` above, which is UMA's own course code.
   */
  match: {
    degreeInterest: string
    areaStudy: string
    mProgram: string
  }
}

export const umaPrograms: UMAProgram[] = [
  {
    slug: 'clinical-medical-assistant',
    routeSlug: 'as-clinical-medical-assistant',
    title: 'Associates in Clinical Medical Assistant',
    shortTitle: 'Clinical Medical Assistant',
    mProgram: 'HS-CMA',
    // 2 = Associates, 5 = Healthcare & Medical Assisting, 500 = Medical Assistant
    match: { degreeInterest: '2', areaStudy: '5', mProgram: '500' },
  },
  {
    slug: 'medical-administrative-assistant',
    routeSlug: 'as-medical-administrative-assistant',
    title: 'Associates in Medical Administrative Assistant',
    shortTitle: 'Medical Administrative Assistant',
    mProgram: 'HS-MAA',
    // 510 = Medical Office Assistant
    match: { degreeInterest: '2', areaStudy: '5', mProgram: '510' },
  },
  {
    slug: 'medical-billing-and-coding',
    routeSlug: 'as-medical-billing',
    title: 'Associates in Medical Billing & Coding',
    shortTitle: 'Medical Billing & Coding',
    mProgram: 'MBCOA',
    // 509 = Medical Billing & Coding
    match: { degreeInterest: '2', areaStudy: '5', mProgram: '509' },
  },
]

export function getUMAProgramByRouteSlug(
  routeSlug: string,
): UMAProgram | undefined {
  return umaPrograms.find((program) => program.routeSlug === routeSlug)
}
